function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-24.971 -745.917)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M85.7,266.135l2.071-3.588a.421.421,0,0,0-.152-.573.415.415,0,0,0-.571.152l-2.1,3.634a13.093,13.093,0,0,0-10.681,0l-2.1-3.634a.42.42,0,1,0-.726.421l2.071,3.588a12.365,12.365,0,0,0-6.39,9.782H92.1A12.362,12.362,0,0,0,85.7,266.135Zm-11.823,6.276a1.046,1.046,0,1,1,1.046-1.046A1.047,1.047,0,0,1,73.881,272.411Zm11.461,0a1.046,1.046,0,1,1,1.046-1.046A1.047,1.047,0,0,1,85.342,272.411Z",
  transform: "translate(-42.158 484)",
  fill: "#39a95e"
}));

var SvgAndroidDeveloper = function SvgAndroidDeveloper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.967,
    height: 14,
    viewBox: "0 0 24.967 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAndroidDeveloper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/android_developer.80596c9f.svg";
export { ForwardRef as ReactComponent };